<template>
  <div v-if="paymentDetails" class="p-h-payment-details">
    <HBorderPanel body-margin="s">
      <template #heading>お支払い内容</template>
      <template #footer>
        <SmallText :size="14" weight="bold">ご利用ポイント合計</SmallText>
        <div class="p-h-payment-details__body">
          <div class="p-h-payment-details__price">
            <span class="p-h-payment-details__price__text">{{
              addComma(paymentDetails.usage_point)
            }}</span>
            <span class="p-h-payment-details__price__unit">ポイント</span>
          </div>
        </div>

        <HContainer margin-size="s">
          <template #content>
            <SmallText :size="14" weight="bold">クレジット決済金額</SmallText>
            <div class="p-h-payment-details__body">
              <div class="p-h-payment-details__price">
                <span class="p-h-payment-details__price__text">{{
                   addComma(paymentDetails.credit_card.amount)
                }}</span>
                <span class="p-h-payment-details__price__unit">円</span>
              </div>
              <div class="p-h-payment-details__note">
                <p>
                  （価格：{{ paymentDetails.credit_card.price }}円／ 消費税{{
                    paymentDetails.credit_card.tax
                  }}円）
                  <br />
                  消費税率：{{ paymentDetails.tax_rate }}％
                </p>
              </div>
            </div>
          </template>
        </HContainer>
      </template>
    </HBorderPanel>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import SmallText from "@/common/components/atoms/SmallText.vue";
import HContainer from "@/general/components/pages/parts/PointHistoryList/HContainer.vue";
import HBorderPanel from "@/general/components/pages/parts/PointHistoryList/HBorderPanel.vue";

@Options({
  props: {
    paymentDetails: { type: [Object, Boolean], default: false }
  },
  components: {
    SmallText,
    HContainer,
    HBorderPanel
  }
})
export default class HPaymentDetails extends Vue {
  paymentDetails!: any | boolean;
}
</script>

<style lang="scss" scoped>
.p-h-payment-details {
  width: 100%;
  text-align: left;

  &__body {
  }

  &__price {
    display: flex;
    align-items: flex-end;
    margin-top: rem(4);

    &__text {
      font-family: $font--roboto;
      font-size: rem(20);
      font-weight: bold;
    }

    &__unit {
      font-size: rem(10);
      display: block;
      padding-bottom: 0.2em;
    }
  }

  &__note {
    font-size: rem(14);
  }
}
</style>
